import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import parse from 'csv-parse/lib/sync'
import { FOCUS } from '../focus'

class GIDResolver {
  constructor(content) {
    this.content = content

    this.projects = new Map()
    this.areas = new Map()
  }

  addParent(parent, parentMap) {
    if (parentMap.has(parent)) {
      return parentMap.get(parent)
    } else {
      const parentId = uuidv4()
      parentMap.set(parent, parentId)
      return parentId
    }
  }

  addProject(project) {
    return this.addParent(project, this.projects)
  }

  addArea(area) {
    return this.addParent(area, this.areas)
  }

  processItem(item) {
    const todo = {}
    todo.name = item.Name !== '' ? item.Name : null
    if (todo.name === null) {
      return null
    }

    todo.status = item.Completed !== '' ? 'done' : null
    todo.start =
      item['Due Date'] !== ''
        ? moment(item['Due Date'], 'MM/DD/YYYY').format('YYYY-MM-DD')
        : null
    //todo.creationDate = attributes[3]
    todo.area = item.Area !== '' ? this.addArea(item.Area) : null
    todo.project = item.Project !== '' ? this.addProject(item.Project) : null
    todo.tags = item.Tags !== '' ? item.Tags : null
    //todo.createdBy = attributes[7]
    //todo.assignedTo = attributes[8]
    todo.description = item.Note !== '' ? item.Note : null
    //todo.numOfAttachments = attributes[10]
    //todo.repeats = attributes[11]
    //todo.commentsBy = attributes[12]

    switch (item.Focus) {
      case 'Next':
        todo.list = FOCUS.NEXT.id
        break
      case 'Someday':
        todo.list = FOCUS.SOMEDAY.id
        break
      case 'Scheduled':
      case 'Today':
        todo.list = FOCUS.TODAY.id
        break
      case 'Waiting For':
        todo.list = FOCUS.WAITING.id
        break
      case 'Reference':
        todo.list = FOCUS.NOTES.id
        break
      default:
        todo.list = FOCUS.INBOX.id
    }

    return todo
  }

  convertMapToNamedObjects(mapItems) {
    const namedObjects = []
    for (const [key, value] of mapItems) {
      namedObjects.push({
        name: key,
        id: value
      })
    }
    return namedObjects
  }

  itemIsGID(item) {
    if (
      Object.prototype.hasOwnProperty.call(item, 'Name') &&
      Object.prototype.hasOwnProperty.call(item, 'Completed') &&
      Object.prototype.hasOwnProperty.call(item, 'Due Date') &&
      Object.prototype.hasOwnProperty.call(item, 'Creation Date') &&
      Object.prototype.hasOwnProperty.call(item, 'Area') &&
      Object.prototype.hasOwnProperty.call(item, 'Project') &&
      Object.prototype.hasOwnProperty.call(item, 'Tags') &&
      Object.prototype.hasOwnProperty.call(item, 'Created By') &&
      Object.prototype.hasOwnProperty.call(item, 'Assigned To') &&
      Object.prototype.hasOwnProperty.call(item, 'Note') &&
      Object.prototype.hasOwnProperty.call(item, '# Attachments') &&
      Object.prototype.hasOwnProperty.call(item, 'Repeats') &&
      Object.prototype.hasOwnProperty.call(item, 'Comments by') &&
      Object.prototype.hasOwnProperty.call(item, 'Focus')
    ) {
      return true
    }
    return false
  }

  resolve() {
    try {
      const data = {
        areas: [],
        projects: [],
        tags: [],
        todos: []
      }

      const records = parse(this.content, { columns: true, cast_date: false })
      if (records && records.length > 0 && this.itemIsGID(records[0])) {
        data.todos = records.map(item => {
          return this.processItem(item)
        })

        data.areas = this.convertMapToNamedObjects(this.areas)
        data.projects = this.convertMapToNamedObjects(this.projects)
        return data
      }
      return null
    } catch (err) {
      return null
    }
  }
}

export default GIDResolver
